import { Box } from "@mui/material";
import type { ReactNode } from "react";
import { CloseButton } from "./CloseButton";

/** Standard header row for side panels and dialogs: title + optional close button. */
export function PanelHeader({
  titleId,
  title,
  subtitle,
  closeAriaLabel,
  onClose,
  children,
}: {
  titleId: string;
  title: ReactNode;
  subtitle?: ReactNode;
  closeAriaLabel?: string;
  onClose?: () => void;
  children?: ReactNode;
}) {
  return (
    <Box className="records-modal-toolbar">
      {subtitle ? (
        <div className="panel-header-title-group">
          <h2 id={titleId}>{title}</h2>
          <p className="users-group-modal-subtitle">{subtitle}</p>
        </div>
      ) : (
        <h2 id={titleId}>{title}</h2>
      )}
      {children}
      {onClose && closeAriaLabel ? <CloseButton ariaLabel={closeAriaLabel} onClick={onClose} /> : null}
    </Box>
  );
}

/** Standard footer row for side panels and dialogs (Cancel / primary action). */
export function PanelActions({ children }: { children: ReactNode }) {
  return <Box className="records-modal-actions">{children}</Box>;
}
